import React from "react";
import { useParams } from "react-router-dom";
import AudienceBuilderV2 from "../../components/builder-v2/AudienceBuilderV2";

function BuilderV2View() {
	const params = useParams();
	const cohortId = params.id ?? null;

	return <AudienceBuilderV2 mode="view" cohortId={cohortId} />;
}

export default BuilderV2View;
